export default __webpack_public_path__ + "static/schedule-b6f746bd823b9ed1be097f7b0003c03e.png";